<template>
  <div>
    <div class="printPage" ref="print">
      <div class="left">
        <span style="left: 0px; top: 105px">RAKUMART</span><!--发件公司-->
        <span style="left: 0px; top: 260px">RAKUMART</span><!--公司。-->
        <span style="left: 0px; top: 160px" v-html="$parent.textToHtml(companyAddress)">
        </span><!--公司地址。-->
        <span style="left: 0px; top: 190px"></span><!--公司地址。-->
        <span style="left: 102px; top: 234px">322000</span><!--公司。-->
        <span style="left: 102px; top: 260px">{{ mobile }}</span><!--电话。-->
        <span style="left: 100px; top: 455px; height: 45px;">{{
          specifiedFormatDate({ format: "yyyy mm dd" })
        }}</span><!--电话。-->
      </div>
      <div class="right">
        <span style="left: 508px; top: 0px">{{ $route.query.sn || "" }}</span>
        <span style="left: 256px; top: 105px">{{ receiver.company }}</span><!--名称-->
        <span style="left: 256px; top: 160px;width: 300px;"
          v-html="$parent.textToHtml(receiver.address)"></span><!--地址-->
        <span style="left: 426px; top: 234px">{{ receiver.zip_code }}</span><!--邮编-->
        <span style="left: 346px; top: 205px">日本</span><!--邮编-->
        <span style="left: 287px; top:260px;width: 130px;" :class="{ maxLength: receiver.contacts.length > 17 }">{{
          receiver.contacts }}様</span><!--收件人-->
        <span style="left: 426px; top: 260px">{{ receiver.mobile }}</span><!--手机号-->
        <span style="left: 286px; top: 288px">{{ receiver.contacts_roma }}</span><!--罗马字名-->
      </div>
    </div>

    <div class="btn">
      <el-button type="primary" @click="save"> 复制页面代码数据</el-button>
      <el-button type="primary" @click="print"> 打印</el-button>
    </div>
  </div>
</template>
<script>
import { specifiedFormatDate } from "@/utlis/date";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      receiver: (state) => state.porderDetail.receiver, //进口商信息
    }),
    // 显示的公司地址,根据传入部门区分不同地址,默认使用五楼的地址
    companyAddress() {
      switch (this.$route.query.department) {
        case "一部":
          return `3th Floor, Unit2,NO.37Jingsan
Road,Beiyuan Street,
Yiwu City,Zhejiang Province`;
          break;
        case "二部":
          return `4th Floor, Unit2,NO.37Jingsan
Road,Beiyuan Street,
Yiwu City,Zhejiang Province`;
          break;
        case "三部":
          return `5th Floor, Unit2,NO.37Jingsan
Road,Beiyuan Street,
Yiwu City,Zhejiang Province`;
          break;
        default:
          break;
      }
      return;
    },
    mobile() {
      switch (this.$route.query.department) {
        case "一部":
          return `15067546083`;
          break;
        case "二部":
          return `18606888793`;
          break;
        case "三部":
          return `18268222365`;
          break;
        default:
          break;
      }
      return;
    },
  },
  data() {
    return { specifiedFormatDate };
  },
  mounted() {
    // this.print()
  },
  methods: {
    print() {
      this.$nextTick(() => {
        this.$print(this.$refs.print);
      });
      // this.$print(this.$refs.print)
    },
    save() {
      let copyUrl = this.$refs.print.innerHTML;
      let oInput = document.createElement("input"); //创建一个隐藏input（重要！）
      oInput.value = copyUrl; //赋值
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = "oInput";
      oInput.style.display = "none";

      alert("复制成功");
      // console.log(copyUrl);
    },
  },
};
</script>
<style lang="scss" scoped>
.btn {
  margin: 20px auto;
  text-align: center;
}

.printPage {
  width: 836px;
  height: 532px;
  position: relative;
  color: #000;
  font-family: "Helvetica Neue";

  .maxLength {
    height: 70px;
    top: 240px !important;
  }

  .left {
    float: left;
    width: 416px;
    height: 532px;
    left: 0;
  }

  .right {
    float: right;
    width: 416px;
    height: 532px;
    left: 0;
    /*right: 0;*/
  }

  #printPage {
    width: 836px;
    height: 532px;
    position: relative;
  }

  span {
    font-size: 14px !important;
    display: block;
    position: absolute;

  }
}
</style>
